
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire47c9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire47c9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fsC6G", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b41707c0dd8fdd22$export$6503ec6e8aabbaf; }, function (v) { return $b41707c0dd8fdd22$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b41707c0dd8fdd22$export$f7ad0328861e2f03; }, function (v) { return $b41707c0dd8fdd22$export$f7ad0328861e2f03 = v; });
var $b41707c0dd8fdd22$export$6503ec6e8aabbaf;
var $b41707c0dd8fdd22$export$f7ad0328861e2f03;
"use strict";
var $b41707c0dd8fdd22$var$mapping = new Map();
function $b41707c0dd8fdd22$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b41707c0dd8fdd22$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b41707c0dd8fdd22$var$resolve(id) {
    var resolved = $b41707c0dd8fdd22$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b41707c0dd8fdd22$export$6503ec6e8aabbaf = $b41707c0dd8fdd22$var$register;
$b41707c0dd8fdd22$export$f7ad0328861e2f03 = $b41707c0dd8fdd22$var$resolve;

});

var $ebdcdf500c231a58$exports = {};

(parcelRequire("fsC6G")).register(new URL("", import.meta.url).toString(), JSON.parse('["b21yj","index.56d8f76a.js","hUp9w","game.044a2988.js"]'));


//# sourceMappingURL=index.runtime.18285d29.js.map
